import { toRef, onMounted, onUnmounted } from 'vue';
import { useFocusElement } from '@/composables/useFocusableElements'

export function useFocusTrap(component, callback) {
  const root = toRef(component);

  const { focusFirstElement, getFocusableChildren } = useFocusElement(root);

  function trapFocus(event) {
    if (!root.value) return;

    const focusableChildren = getFocusableChildren();
    const firstElement = focusableChildren[0];
    const lastElement = focusableChildren[focusableChildren.length - 1];

    if (event.key === 'Tab') {
      if (event.shiftKey) {
        if (document.activeElement === firstElement) {
          event.preventDefault();
          lastElement.focus({ focusVisible: true });
        }
      } else {
        if (document.activeElement === lastElement) {
          event.preventDefault();
          firstElement.focus({ focusVisible: true });
        }
      }
    }
  }

  function activate() {
    focusFirstElement();
  }

  onMounted(() => document.addEventListener('keydown', trapFocus))
  onUnmounted(() => document.removeEventListener('keydown', trapFocus))

  return { activate }
}
